import BaseQuery from "@/stateManagement/BaseQuery";
import MediaListStore, {
    MediaListState,
} from "@apps/iloom_customization/design_feed/stores/MediaListStore";
import { singleton } from "tsyringe";

@singleton()
export class MediaListQuery extends BaseQuery<MediaListState> {
    constructor(store: MediaListStore) {
        super(store);
    }
    mediaList$ = this.select((s) => s.mediaList);
    meta$ = this.select((state) => state.meta);
    status$ = this.select((s) => s.status);
    loadMoreStatus$ = this.select((s) => s.loadMoreStatus);
}
